import React, { useState } from 'react';
import { Col, Image, Modal } from 'react-bootstrap';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useDeletePropertyImageMutation } from '../../../lib/apiSlice/property/propertySlice.tsx';
import { toast } from 'react-toastify';

const ImageGallery = ({ apartmentId, images = [] }) => {
    const [selectedImageId, setSelectedImageId] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [deletePropertyImage] = useDeletePropertyImageMutation();

    const openModal = (imageId) => {
        setSelectedImageId(imageId);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setSelectedImageId(null);
        setIsModalOpen(false);
    };

    const handleDeleteImage = async () => {
        if (!selectedImageId) return;

        try {
            await deletePropertyImage({ id: selectedImageId }).unwrap();
            toast.success('Successfully deleted the image');
            closeModal();
        } catch (error) {
            console.error(error);
            closeModal();

        }
    };

    const slickSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: Math.max(1, Math.min(3, images.length)),
        slidesToScroll: 1,
    };

    return (
        <>
            {images.length > 0 ? (
                <div>
                    <Slider {...slickSettings} style={{ marginLeft: '0rem' }}>
                        {images.map((image) => (
                            <div key={image.id}>
                                <Col md={6} sm={6} style={{ marginTop: '1rem', position: 'relative' }}>
                                    <span
                                        onClick={() => openModal(image.id)}
                                        style={{
                                            position: 'absolute',
                                            top: '10px',
                                            right: '10px',
                                            padding: '0.5rem',
                                            backgroundColor: 'red',
                                            borderRadius: '50%',
                                            cursor: 'pointer',
                                            zIndex: 1,
                                        }}
                                    >
                                        <i className='bi bi-trash-fill text-white'></i>
                                    </span>
                                    <Image className='propertiesViewImage' src={image.image} fluid />
                                </Col>
                            </div>
                        ))}
                    </Slider>

                    <Modal show={isModalOpen} onHide={closeModal} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Delete Image</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p>Are you sure you want to delete this image?</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <button className='btn btn-danger' onClick={handleDeleteImage}>
                                Delete
                            </button>
                            <button className='btn btn-secondary' onClick={closeModal}>
                                Cancel
                            </button>
                        </Modal.Footer>
                    </Modal>
                </div>
            ) : (
                <p style={{ fontSize: "2rem", textAlign: 'center', marginTop: '2rem' }}>
                    No Images found, kindly add one.
                </p>
            )}
        </>
    );
};

export default ImageGallery;
